export default {
  PARAM_EnvoirmentVariable:1,
  
  //ServiceBaseurl:'http://mmmuatapi-env.eba-y3ze7gkv.us-east-1.elasticbeanstalk.com/',
  ServiceBaseurl:'https://uat-mmm-api.trigma.ai/',
  //ServiceBaseurl:'https://viivapi.trigma.ai/',
  //ServiceBaseurl:'https://uat-mmm-api.trigma.ai/',
  //baseURL:"http://trigmammmbackend-env.eba-rqnbsrhr.ap-south-1.elasticbeanstalk.com/",
  appname: "Modelling Platform",
  appid: 1,
  //PARAM_GLOBAL_LOGIN:"https://viiv.trigma.ai/#/",
  //PARAM_GLOBAL_HOME:"https://viiv.trigma.ai/#/extraauth?user_id=",

  PARAM_GLOBAL_LOGIN:"https://uat-mmm.trigma.ai/#/",
  PARAM_GLOBAL_HOME:"https://uat-mmm.trigma.ai/#/extraauth?user_id=",

  //steps
  PARAM_Step_MDP_SP_PS:"1",
  PARAM_Step_MDP_SP_DM:"2",
  PARAM_Step_MDP_DE_U:"3",
  PARAM_Step_MDP_DE_B:"4",
  PARAM_Step_MDP_S:"5",
  PARAM_Step_MDP_AS:"6",
  PARAM_Step_MDP_DVC:"7",
  PARAM_Step_MDP_LCVC:"8",
  PARAM_Step_MDP_SVC:"9",
  PARAM_Step_MDP_VT:"10",
  PARAM_Step_MDP_SVT:"11",


  ICON_DASHBOARD:"mdi-dropbox",
  ICON_SetuptheProject:"mdi-projector-screen",
  ICON_DataExploration:"mdi-database-check",
  ICON_ModelDataPrepration:"mdi-cable-data",
  ICON_BuildtheModel:"mdi-wrench-outline",
  


  setparmInlocalStorage(varparmurl) {
    localStorage.setItem("Parm_QueryString", varparmurl);
  },
  getparmInlocalStorage() {
    return localStorage.getItem("Parm_QueryString");
  },
  getparmvaluefromQueryString(urlparm, parmname) {
    let urlParams = new URLSearchParams(urlparm);
    let tt = urlParams.get(parmname);
    return tt;
  },
  convertbooltoint(varbool) {
    //alert(varbool);
    //result ? 1 : 0;
    let ivalue = varbool ? 1 : 0;

    return ivalue;
  },
};
